import { useCallback, useState } from 'react';

interface UseBatteryLevelReturn {
	batteryLevel: number;
	increaseBattery: () => void;
	decreaseBattery: () => void;
	isBatteryDepleted: boolean;
	resetBattery: () => void;
}

const INITIAL_BATTERY_LEVEL = 3;
const MAX_BATTERY_LEVEL = 5;
const MIN_BATTERY_LEVEL = 0;

/**
 * Custom hook to manage battery level in the Time Game
 * - Starts at level 3
 * - Increases on correct answer (max 5)
 * - Decreases on wrong answer
 * - Game is lost when level reaches 0
 */
const useBatteryLevel = (): UseBatteryLevelReturn => {
	const [batteryLevel, setBatteryLevel] = useState<number>(INITIAL_BATTERY_LEVEL);

	const increaseBattery = useCallback(() => {
		setBatteryLevel((prevLevel) => Math.min(prevLevel + 1, MAX_BATTERY_LEVEL));
	}, []);

	const decreaseBattery = useCallback(() => {
		setBatteryLevel((prevLevel) => Math.max(prevLevel - 1, MIN_BATTERY_LEVEL));
	}, []);

	const resetBattery = useCallback(() => {
		setBatteryLevel(INITIAL_BATTERY_LEVEL);
	}, []);

	const isBatteryDepleted = batteryLevel <= MIN_BATTERY_LEVEL;

	return {
		batteryLevel,
		increaseBattery,
		decreaseBattery,
		isBatteryDepleted,
		resetBattery,
	};
};

export default useBatteryLevel;
